import React from 'react';
import { FiArrowUp } from 'react-icons/fi';
import useThemeColors from '../../hooks/useThemeColors';

const AnalyticsCard = ({ 
  title, 
  value, 
  growth, 
  icon: Icon, 
  iconColor = "text-blue-500", 
  borderColor = "border-l-blue-500",
  subtitle,
  showGrowth = true,
  className = ""
}) => {
  const { isDark, colors } = useThemeColors();
  
  return (
    <div className={`--theme-colors rounded-lg shadow-md border-l-4 ${borderColor} ${className}`}>
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              {title}
            </p>
            <p className="text-2xl font-bold --theme-colors">{value}</p>
            {subtitle && (
              <p className={`text-sm mt-1 ${isDark ? 'text-gray-500' : 'text-gray-500'}`}>
                {subtitle}
              </p>
            )}
            {showGrowth && growth && (
              <div className="flex items-center gap-1 mt-1">
                <FiArrowUp className={`w-4 h-4 ${isDark ? 'text-green-400' : 'text-green-500'}`} />
                <span className={`text-sm font-medium ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                  +{growth}%
                </span>
              </div>
            )}
          </div>
          {Icon && (
            <div className={`w-8 h-8 ${iconColor}`}>
              <Icon />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalyticsCard; 